<template>
  <div>
      <modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>
      <updateCollection v-if="documentId" v-bind:documentId="documentId"  @close="closeModalCollection()"></updateCollection>
      <updateBulkCollection v-if="bulkUpdate" v-bind:items="selectedItems" @close="closeModalCollection()"></updateBulkCollection>
       <div class="card">
        <div class="card-header bg-active">
            <h4 class="header">LISTA DOCUMENTI FORNITORE  - 
              
               <span style="color:blue; font-size:24px" ><strong> {{name}}</strong></span>

              </h4>
             <small id="Help" style="color:brown" class="form-text "><strong>doppio click apre documento.</strong></small>
        </div>
        
      <div class="card-body">
     
      <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive">
      <table class="table table-hover table-sm  table-striped mb-0" id="table">
        
      <thead>
        <tr>

          <th>#</th>
      
          <th></th>
          <th>
            COLLEZIONE
          </th>
          <th>TIPO</th>
          <th></th>
          <th>BRAND/STAGIONE ANAGRAFICA PRODOTTO</th>
          <th class="text-right">TOTALE Q.TA'</th>
          <th class="text-right">TOTALE IMPONIBILE</th>
          <th class="text-right">TOTALE IVA</th>
          <th class="text-right">TOTALE €</th>
          <th>NUMERO</th>
          <th>DATA</th>
          <th>SEDE</th>
          <th>CREATO IL</th>
          <th>STAMPA ETICHETTE (jsPM)</th>
          <th>STAMPA ETICHETTE (Zebra)</th>
              
        </tr>
      </thead>
      <tbody>
      <tr @click.ctrl=setItem(item) data-toggle="tooltip" title="doppio click modifica documento" @dblclick="openDocument(item)" class="pointer" v-for="(item,index) in filteredDocuments" :key="index">
        <td>{{index+1}}</td>
        <td>
          <i @click="updateCollection(item,)" data-toggle="tooltip" title="modifica collezione"  class="fa fa-edit" aria-hidden="true">
          
        </i>
        <td>
          {{ item.collection_description }}
        </td>
        </td>
        
        <td>{{item.description}}</td>
        <td>
          <i v-if="item.selected" :style="{color:'red'}" class="fas fa-thumbtack" aria-hidden="true"></i>
        </td>
        <td>{{item.data}}</td>
        <td class="text-right">{{item.totalQty}}</td>
        <td class="text-right">{{fmt1(item.totalTaxableAmount)}}</td>

        <td class="text-right">{{fmt1(item.totalTaxAmount)}}</td>
        <td class="text-right">{{fmt1(item.totalAmount)}}</td>
        <td class="text-left">{{item.number}}</td>
        <td class="text-left">{{item.date}}</td>
        <td class="text-left">{{item.store}}</td>
        <td class="text-left">{{item.create_at}}</td>
        <td>
          <i @click="printModal(item,'EPL')" data-toggle="tooltip" title="stampa etichette EPL"  class="fa fa-print" aria-hidden="true">
          <span v-if="btn1 && spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </i></td>
        <td><i class="fa fa-print"
          @click="printModal(item,'ZPL')" data-toggle="tooltip" title="stampa etichette ZPL"   aria-hidden="true">
          <span v-if="btn2 && spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </i></td>
      </tr>
      </tbody>
      <tfoot>
        <tr>                  
        </tr>
      </tfoot>  
    </table>
  </div>

  
        
  <div class="form-group mt-5">
  <label for="cerca"><strong>Filtra</strong></label>
  <input id="cerca" class="form-control" type="text" name="query" v-model="filterKey">
  </div>
  

  <button v-if="selectedItems.length>0" @click="bulkUpdate=true" class="btn btn-primary mt-1 mb-1">      
      <i class="fas fa-edit mr-2" aria-hidden="true"></i>
      MODIFICA COLLEZIONE DOCUMENTI SELEZIONATI
     
    </button>



  </div>
  </div>

  <div v-if="movementId>0">
    
    <print-epl-modal :key="refreshEPL" v-bind:data='data'></print-epl-modal>
    <printZebraModal :key="refreshZPL" v-bind:data='data'></printZebraModal>  

  </div>
  

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import api                     from '@/api'

import printZebraModal           from '@/components/common/PrintZebraModal.vue';
import printEplModal             from '@/components/common/PrintJSPMModal.vue';
import modalSpinner              from '@/components/common/ModalSpinner.vue'
import updateCollection          from '@/components/backOffice/UpdateMovementCollection.vue'
import updateBulkCollection      from '@/components/backOffice/UpdateBulkCollection.vue'


  export default {

     components: {printZebraModal,printEplModal,modalSpinner,updateCollection,updateBulkCollection},
     props : ['supplierId','name','range'],
    data () {
      return {
        
        bulkUpdate    : false,
        selectedItems : [],
        modalSpinner : {spinner:false,show:false},
        items         : [],
        filterKey     : '',
        spinner       : false,
        movementId    : 0,
        documentId    : 0,
        data          : [],
        refreshEPL    : 0,
        refreshZPL    : 100,
      
        btn1          : false,
        btn2          : false 
                
      }
    },
    watch :
    {

    },
    
  
    computed: {
      ...mapGetters(['company']),
      
       filteredDocuments : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
  
      
    },

    created () 
    {       
      this.getDocuments()
    },
    methods: 
    {
    
    setItem(item)  
    {
      this.selectedItems = []
      item.selected = !item.selected
      
      this.filteredDocuments.forEach(item=>{


        if(item.selected)
        {
          this.selectedItems.push({'stockMovementId':item.movementId})
        }
      })
      
    },
    closeModalCollection()
    {
      this.selectedItems = []
      this.bulkUpdate = false
      this.documentId = 0
      this.getDocuments()
    } ,  
    updateCollection(item)  
    {
      this.documentId = item.documentId
    },  
    fmt1(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },
      setModalSpinner(show)
      {
        

        this.modalSpinner.show = show
        
      },
      getData() 
      {
      

        const data  = {'movementId' : this.movementId}
        const sp    = {'sp':'spMovementBarcodes'}
        const json  = Object.assign(data, sp)
        return new  Promise( async (resolve, reject)  =>  {
        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
               resolve(res.data.recordsets[0])   
            }
           else if(res.status == 500)
           {
                
                
                console.log(res.data)                    
           } 
           else
            { 
                
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          //this.spinner = false
        });          
        
        })

      }, 
    



      async printModal(item,lang)
      {
        this.spinner = true  
        this.btn1  = lang == 'EPL' ? true : false
        this.btn2  = lang == 'ZPL' ? true : false
        this.movementId = item.movementId
        this.data = await this.getData()
        this.spinner = false
        
        if(lang=='EPL')
        {
          this.refreshEPL++
          this.$nextTick(() => {
            $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            })
        }
        else
        {
          this.refreshZPL++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })  
        }
        
      },

      
      
      openDocument(item)
      {
        
        this.$emit('update',item)
      },
      async getDocuments()
      {
        
        
        this.modalSpinner.show    = true
        this.modalSpinner.spinner = true
        this.modalSpinner.title   = 'Caricamento documenti in corso ...'
        
        const data  = {'supplierId' : this.supplierId,'companyId':this.company.Id,'range':this.range}
        const sp    = {'sp'         : 'spSupplierDocuments'}
        const json  = Object.assign(data, sp);

        await api.post(json).then(res => {
          
          if(res.status==200)
            {
             this.modalSpinner.show = false 
             this.items = res.data.recordsets[0] 
            
             this.items.forEach(item => {
              this.$set(item, 'selected', false)
              
             }); 

            }
           else if(res.status==500)
           {
                this.modalSpinner.spinner = false            
                this.modalSpinner.msg = res.data
                console.log(res.data)                             
           } 
           else
            {

                this.modalSpinner.spinner = false            
                this.modalSpinner.msg = res
                console.log('Network Error.')                  
                 
            } 
          
          }).catch(err => {
              
                this.modalSpinner.spinner = false            
                this.modalSpinner.msg = err.message
              
          }).finally(() => {
          
          //this.modalSpinner.show = false
        });



      },
      
      

    }
  }
</script>

<style scoped>
  
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

.my-custom-scrollbar {
    position  : relative;
    height    : 350px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
p,h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }
.header {
  font-family : 'Roboto Condensed';
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .fa-print:hover{

    color : red;
}
 .fa-print{

     color       : brown;

 }
 .text-right{
  
  font-weight  : bold;
  font-size    : 18px;
  
 }
 .text-left{
  
  font-weight  : bold;
  font-size    : 18px;
  
 }
</style>
